// extracted by mini-css-extract-plugin
export default {"description":"changePeriod_description__s14az","content":"changePeriod_content__NEKyv","contentItem":"changePeriod_contentItem__pn6ge","mt12":"changePeriod_mt12__Z5NEf"};